var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"base-markdown-view mdmdt",class:{
    'base-markdown-view--fill': _vm.fill,
    'base-markdown-view--plain': _vm.plain,
  },domProps:{"innerHTML":_vm._s(_vm.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }